import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../../cms/content.service';
import { Producto, TipoProducto } from 'src/app/cms/models';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-work',
    templateUrl: './work.component.html',
    styleUrls: ['./work.component.scss'],
    standalone: false
})
export class WorkComponent implements OnInit {

    productoList: Array<Producto> = [];
    public tamanoTabl = new UntypedFormControl("6");
    tipoProductoList: Array<TipoProducto> = [];
    backupProductoList: Array<Producto> = [];
    public page: number = 1;
    public sortOrder: string = 'year-desc';

    public loadError = '';
    constructor(private content: ContentService) {
    }
    ngOnInit() {
        this.getProductos();
        this.getTipoProductos();
    }
    private textFilter: string = '';
    private tipoFilter: number | string = '';

    applyFilter(filterValue: string) {
        this.textFilter = filterValue.trim().toLowerCase();
        this.page = 1;
        this.applyFilters();
    }

    applyTipoFilter(idTipo: string) {
        this.tipoFilter = idTipo === '' ? '' : Number(idTipo);
        this.page = 1;
        this.applyFilters();
    }

    applySort(sortOrder: string) {
        this.sortOrder = sortOrder;
        this.page = 1;
    }

    get sortedProductoList(): Array<Producto> {
        return [...this.productoList].sort((first, second) => {
            const firstYear = first.anio || 0;
            const secondYear = second.anio || 0;
            const firstTitle = first.titulo || '';
            const secondTitle = second.titulo || '';

            switch (this.sortOrder) {
                case 'year-asc':
                    return firstYear - secondYear;
                case 'title-asc':
                    return firstTitle.localeCompare(secondTitle, 'es');
                case 'title-desc':
                    return secondTitle.localeCompare(firstTitle, 'es');
                default:
                    return secondYear - firstYear;
            }
        });
    }

    private applyFilters() {
        this.productoList = this.backupProductoList.filter((producto: any) => {
            const matchesText = this.textFilter === '' || Object.keys(producto).some((key: string) => {
                return producto[key] != null && producto[key].toString().toLowerCase().includes(this.textFilter);
            });
            const matchesTipo = this.tipoFilter === '' || producto.idTipoProducto === this.tipoFilter;
            return matchesText && matchesTipo;
        });
    }

    getProductos(): void {
        this.content.getPublications().subscribe({
            next: productos => {
                this.backupProductoList = productos;
                this.applyFilters();
            },
            error: () => this.loadError = 'No se pudieron cargar las publicaciones. Intenta de nuevo más tarde.'
        });
    }

    getTipoProductos(): void {
        this.content.getPublicationTypes().subscribe({
            next: tipos => this.tipoProductoList = tipos,
            error: () => this.loadError = 'No se pudieron cargar los tipos de publicación. Intenta de nuevo más tarde.'
        });
    }
}
